<template>
  <div class="page">
    <div
      class="headers"
      :style="headerBack"
      :class="{ back: back }"
    >
      <div
        class="headBox"
        :class="{ shadow: !isTop || !isChange }"
      >
        <div class="headerIcon">
          <img
            :src="headerIcon"
            @click="goHome"
            v-if="back !== 1"
          />
          <img
            src="@/assets/home/headerNav.png"
            @click="goHome"
            v-else
          />
        </div>
        <!-- 标题 -->
        <div class="headerTit">
          <!-- normalColor -->
          <ul v-if="!isTop || !isChange">
            <li
              ref="tain"
              v-for="(ele, index) in headerTit"
              :key="index"
              @mouseover="choiceTit(index)"
              @click="goChoice(index)"
              class="act"
            >
              <el-dropdown
                style="height: 100%"
                placement="bottom"
              >
                <span
                  class="el-dropdown-link font2"
                  :style="herderTits"
                  style="height: 100%; display: inline-block; font-size: 16px"
                  :class="tabN == index ? 'normalColor' : ''"
                  v-if="back !== 1"
                >{{ ele.tit }}</span>
                <span
                  class="el-dropdown-link font2"
                  style="
                    height: 100%;
                    display: inline-block;
                    font-size: 16px;
                    color: rgb(102, 102, 102);
                  "
                  :class="tabN == index ? 'normalColor' : ''"
                  v-else
                >{{ ele.tit }}</span>
                <el-dropdown-menu
                  slot="dropdown"
                  style="
                    margin: 1px 0 0 0;
                    padding: 0;
                    border-radius: 3px;
                    border: none;
                  "
                >
                  <el-dropdown-item
                    v-for="(item, index) in tablists"
                    :key="index"
                    @click.native="goRouter(index)"
                  >{{ item }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
          <ul v-if="isTop && isChange">
            <li
              ref="tain"
              v-for="(ele, index) in headerTit"
              :key="index"
              @mouseover="choiceTit(index)"
              @click="goChoice(index)"
            >
              <el-dropdown
                style="height: 100%"
                placement="bottom"
              >
                <span
                  class="el-dropdown-link font"
                  :style="herderTits"
                  style="height: 100%; display: inline-block; font-size: 16px"
                  :class="tabN == index ? 'normalColor' : ''"
                >{{ ele.tit }}</span>
                <el-dropdown-menu
                  slot="dropdown"
                  style="
                    margin: 1px 0 0 0;
                    padding: 0;
                    border-radius: 3px;
                    border: none;
                  "
                >
                  <el-dropdown-item
                    v-for="(item, index) in tablists"
                    :key="index"
                    @click.native="goRouter(index)"
                  >{{ item }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
        <!-- 二维码 -->
        <div
          class="navCode"
          v-if="noSignin"
        >
          <!-- 弹出框 -->
          <el-popover
            placement="top-start"
            width="245"
            trigger="hover"
          >
            <div class="concat">
              <div class="qcode_wrap clearFix">
                <div class="qcode_left">
                  <img
                    style="width: 80px; height: 80px"
                    src="@/assets/rightNav/vico.jpg"
                    alt=""
                  />
                </div>
                <div class="qcode_right">
                  <img
                    style="width: 80px; height: 80px; margin-top: -1px"
                    src="@/assets/rightNav/zhushou.jpg"
                    alt=""
                  />
                </div>
              </div>
              <p class="text">扫码添加小助手微信</p>
            </div>
            <div
              slot="reference"
              :style="phoneButton"
              class="contactinformation"
            >
              联系方式
            </div>
          </el-popover>
          <div
            class="logigButton"
            :style="loginButton"
            @click="goLogin"
          >
            登录/注册
          </div>
        </div>
        <!-- 登录成功 -->
        <div
          class="userInfoSuccess"
          v-if="isSignin"
        >
          <!-- {{ $headImgUrl}} -->
          <el-dropdown
            @command="handelCommand"
            style="display: flex"
          >
            <span
              class="el-dropdown-link userInfo"
              style="display: flex; align-items: center"
              v-if="userinfo"
            >
              <!-- <el-avatar :size="40" :src="userinfo.avatar_url==='/static/img/avatar_photo.png'?'':base+ userinfo.avatar_url" @error="errorHandler"> -->
              <el-avatar
                :size="40"
                @error="errorHandler"
              >
                <img :src="
                    userinfo.avatar_url == '/static/img/avatar_photo.png'
                      ? $headImgUrl
                      : userinfo.avatar_url
                  " />
              </el-avatar>
              <span
                style="font-size: 14px; margin-left: 10px; color: #606266"
                v-if="!isTop || !isChange"
              >{{ userinfo.nick }}</span>
              <span
                style="font-size: 14px; margin-left: 10px; color: white"
                v-if="isTop && isChange"
              >{{ userinfo.nick }}</span>
              <span
                style="
                  font-size: 14px;
                  margin-left: 10px;
                  color: #606266;
                  line-height: 40px;
                "
                v-if="!isTop || !isChange"
              >{{ userinfo.phone }}
              </span>
              <span
                style="
                  font-size: 14px;
                  margin-left: 10px;
                  color: white;
                  line-height: 40px;
                "
                v-if="isTop && isChange"
              >{{ userinfo.phone }}
              </span>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              style="border: none"
            >
              <el-dropdown-item
                icon="el-icon-s-custom"
                command="b"
              >账户管理</el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-switch-button"
                command="c"
              >退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import api from "@/api/index.js";
import baseUrl from "@/api/common.js";
import apis from "@/api/personallnfo.js";
export default {
  data() {
    return {
      change: "change",
      shadow: "shadow",
      isTop: true,
      tabN: null,
      tags: false,
      n: null,
      isShadow: true,
      tablists: [],
      marginLeft: "auto",
      marginRight: "auto",
      justifyContent: "flex-start",
      headerTit: [
        { tit: "最新活动", type: 2 },
        { tit: "题库模考", type: 3 },
        { tit: "课程", type: 1 },
        { tit: "机经", type: 4 },
        { tit: "干货", type: 5 },
      ],
      list1: ["全能杀G班", "VIP一对一"],
      list2: ["免费公开课", "最新刷题班"],
      list3: ["题库搜题", "在线练习", "仿真模考", "记录"],
      list4: ["机经扫盲", "换库统计", "机经下载"],
      list5: ["考试入门介绍", "各科学习指南", "高分学员分享", "最强王炸资料"],
      tabCell: false,
      noSignin: true, //没有登录
      isSignin: false, //已登录
      // userInfo: {},
      // headerBack:''
      headerBack: {
        backgroundColor: "",
      },
      herderTits: {
        color: "hsla(0,0%,100%,.8)",
      },
      loginButton: {
        backgroundColor: "white",
        color: " rgba(0,0,0,.8)",
      },
      phoneButton: {
        background: "hsla(0,0%,100%,.08)",
        border: "1px solid hsla(0,0%,100%,.8)",
      },
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      // a1:'',
      // a2:'',
      base: baseUrl,
    };
  },
  props: {
    isChange: {
      type: Boolean,
      default: false,
    },
    back: Number,
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  methods: {
    errorHandler() {
      return true;
    },
    test() {
      alert(111);
    },
    ...mapActions(["getUserinfo"]),
    // 鼠标移开二级导航栏时
    hidenTag() {
      this.tags = false;
    },
    changeStyle() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop === 0 && this.isChange) {
        this.headerBack = {
          background: "",
        };
        this.herderTits = {
          color: "hsla(0,0%,100%,.8)",
          // color:'red'
        };
        // this.headerIcon = require('@/assets/bottom/bottomIcon.png')
      }
    },
    goHome() {
      this.$router.push("/home");
    },
    goChoice(index) {
      console.log(index);
      switch (index) {
        case 5:
          return this.$router.push("/calendar");
        default:
          event.preventDefault();
          break;
      }
      this.tags = false;
    },
    choiceTit(index) {
      if ([3, 4].includes(index)) {
        this.marginLeft = "auto";
        this.marginRight =
          document.body.offsetWidth -
          (this.$refs.tain[index].offsetLeft +
            this.$refs.tain[index].offsetWidth) +
          "px";
        this.justifyContent = "flex-end";
      } else {
        this.justifyContent = "flex-start";
        this.marginRight = "auto";
        this.marginLeft = this.$refs.tain[index].offsetLeft + "px";
      }
      if (index == 0) {
        this.tablists = this.list2;
        this.n = index;
        this.tabN = index;
        this.tags = true;
      }
      if (index == 1) {
        this.tablists = this.list3;
        this.n = index;
        this.tabN = index;
        this.tags = true;
      }
      if (index == 2) {
        this.tablists = this.list1;
        this.n = index;
        this.tabN = index;
        this.tags = true;
      }
      if (index == 3) {
        this.tablists = this.list4;
        this.n = index;
        this.tabN = index;
        this.tags = true;
      }
      if (index == 4) {
        this.tablists = this.list5;
        this.n = index;
        this.tabN = index;
        this.tags = true;
      }
      console.log(this.tablists);

      if (index == 5) {
        this.tablists = "";
        this.tabN = index;
        this.tags = false;
      }
      // let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      // if (scrollTop === 0 && this.isChange) {
      // this.headerBack = {
      //   background : '#ffffff'
      // }
      // this.herderTits = {
      //   color:'rgb(102,102,102)'
      // }
      // this.headerIcon = require('@/assets/home/headerNav.png')
      // }
      console.log(this.n);
    },
    goRouter(indexs) {
      console.log(indexs);
      if (this.n == 0) {
        switch (indexs) {
          case 0:
            this.$router.push("/openClass/free");
            // a1.click();
            break;
          case 1:
            this.$router.push("/openClass/newest");
            // a2.click();
            break;
        }
      } else if (this.n == 1) {
        switch (indexs) {
          case 0:
            this.$router.push("/questionStock");
            break;
          case 1:
            this.$router.push("/onlinePractice");
            break;
          case 2:
            this.$router.push("/questionbank");
            break;
          case 3:
            this.$router.push("/allsubjectcontent");
            break;
        }
      } else if (this.n == 2) {
        switch (indexs) {
          case 0:
            this.$router.push("/springClass");
            break;
          case 1:
            this.$router.push("/onOne");
            break;
        }
      } else if (this.n == 3) {
        switch (indexs) {
          case 0:
            this.$router.push("/saomang");
            break;
          case 1:
            this.$router.push("/tongji");
            break;
          case 2:
            this.$router.push("/freeDown");
            break;
        }
      } else {
        switch (indexs) {
          case 0:
            this.$router.push("/introduction");
            break;
          case 1:
            this.$router.push("/matsList");
            break;
          case 2:
            this.$router.push("/hightScore");
            break;
          case 3:
            this.$router.push("/mostData");
            break;
        }
      }
      this.tags = false;
    },
    handelCommand(command) {
      if (command == "b") {
        this.$router.push("/accountSettings");
      } else {
        this.goOut();
      }
    },
    goLogin() {
      this.isSignin = false;
      this.$router.push("/login");
    },
    //移入头像
    tabCellBlock() {
      this.tabCell = true;
    },
    tabCellHidden() {
      this.tabCell = false;
    },
    //退出
    goOut() {
      api
        .goLoginOut()
        .then((res) => {
          localStorage.removeItem("token");
          this.goLogin("/?updata=1");
        })
        .catch((err) => {
          console.log("退出失败");
        });
    },
    // 获取信息
    getUserInfo() {
      apis
        .getPersonInfo()
        .then((res) => {
          console.log(res);
          this.userInfo = res.data.data;
        })
        .catch((err) => {
          this.$message.error("获取数据失败");
        });
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.isSignin = true;
      this.noSignin = false;
      this.getUserinfo();
    } else if (sessionStorage.getItem("token")) {
      this.isSignin = true;
      this.noSignin = false;
      this.getUserinfo();
    } else {
      this.isSignin = false;
      this.noSignin = true;
    }
  },
};
</script>

<style scoped="scoped">
.clearFix:after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.qcode_left {
  float: left;
  width: 50%;
  text-align: center;
}
.back {
  background-color: #fff;
  color: #000000 !important;
}

.qcode_right {
  float: right;
  width: 50%;
  text-align: center;
}

.concat .text {
  text-align: center;
  margin-top: 10px;
}

.navBack {
  height: 45px;
  width: 100%;
  background: #e2e4e5;
  position: absolute;
}

.headers {
  width: 100%;
  min-width: 1250px;
  height: 79px;
  display: flex;
  align-items: center;
  /* box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06); */
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  position: relative;
  /* z-index: 9999; */
}

.headers.shadow {
  background-color: red;
}
.headerIcon img {
  width: 91px;
  height: 31px;
  margin-right: 57px;
}

.headerTit ul {
  flex: 1;
  width: 120%;
  display: flex;
  margin-left: -10%;
  flex: 1;
}

.headerTit ul li {
  margin-left: 50px;
  list-style: none;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  cursor: default;
  height: 79px;
  line-height: 79px;
  cursor: pointer;
}

.headerTag {
  height: 45px;
  width: 100%;
  background: #010a0faf;
  position: absolute;
  min-width: 1200px;
  z-index: 9999;
  opacity: 0.85;
  font-size: 14px;
}

.headerTag ul {
  display: flex;
  height: 45px;
  line-height: 45px;
}

.headerTag ul :first-child {
  margin-left: 0 !important;
}

.headerTag ul li {
  list-style: none;
  margin-left: 60px;
  color: #ffffff;
  cursor: pointer;
}

.headerTag ul li:hover {
  color: rgb(97, 138, 255) !important;
  font-weight: bold !important;
}

.navCode {
  display: flex;
  align-items: center;
  margin-left: 13%;
}

.navCode img {
  width: 24px;
  height: 24px;
}

.navCode div {
  width: 125px;
  height: 40px;
  /* background: #339FEF; */
  /*    background-color: hsla(0,0%,100%,.08); */
  border-radius: 5px;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  margin-left: 20px;
  cursor: pointer;
  /*    border: 1px solid hsla(0,0%,100%,.8); */
}

.tabActive {
  color: #339fef !important;
}

.userInfoSuccess {
  margin-left: 15%;
  position: relative;
  /* background-color: red; */
}

.userInfoSuccess img {
  height: 45px;
  width: 42px !important;
}

.userInfoSuccess span {
  color: white;
}

.userInfoSuccess span.change {
  color: #606266;
}

.userTabCell {
  width: 200px;
  height: auto;
  background: #ffffff;
  margin-left: -145px;
  margin-top: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  position: absolute;
}

.userTabCell ul li {
  list-style: none;
  height: 45px;
  line-height: 45px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
}

.userTabCell ul li:hover {
  background-color: #339fef;
  color: #ffffff;
  cursor: pointer;
}

.headerTag_over-enter-active {
  transition: all 0.6s ease;
}

.headerTag_over-leave-active {
  transition: all 0.5s ease;
}

.headerTag_over-enter,
.headerTag_over-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.headBox {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 10%;
  margin: 0 auto;
  justify-content: space-between;
  z-index: 10000;
  /* background-color: gold; */
}

.headBox.shadow {
  box-shadow: 0 5px 5px -5px #efefef;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  /* background-color: red; */
}

.whites {
  font-weight: bold !important;
  color: white !important;
}

@media screen and (max-width: 1400px) {
  .headerTit ul li {
    margin-left: 38px;
  }
}

.el-popper /deep/ .popper__arrow {
  border-bottom-color: #1ebef4 !important;
  left: 50% !important;
  visibility: hidden;
}

.el-dropdown-menu__item:hover {
  /* color: #618aff; */
  border-left: 4px solid #618aff;
  box-sizing: border-box;
  background-color: white;
}

.el-dropdown-link:focus {
  outline: none;
}

#dropdown-menu-5641 > li:hover {
  background-color: white;
}
.el-dropdown-link.userInfo img {
  width: 50px;
  height: 50px;
}

.el-dropdown-link.userInfo > span:hover {
  cursor: pointer;
}
.font:hover {
  font-weight: bold;
  color: white !important;
}
.font2:hover {
  font-weight: bold;
  color: rgb(97, 138, 255) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue